import qs from 'qs';
import { network } from 'services/network';

import { QueryParams } from 'api/queries/getRisk.query';

export const getRisk = (params: QueryParams) => {
    const querystring = qs.stringify(params, { addQueryPrefix: true, skipNulls: true });

    const url = `api/bo/getRisk${querystring}`;

    return network.get(url).then((response) => {
        return response.data;
    });
};
